export default __webpack_public_path__ + "static/media/a05b4eeb9c75e94ef707726d3296cb19.jpg";